module.exports = __webpack_public_path__ + "static/media/hearst.e76b1186.png";